// DownloadPopup.js
import React from 'react';

const DownloadPopup = ({ message, showPopup }) => {
    return (
        showPopup && <div className="download-popup">{message}</div>
    );
};

export default DownloadPopup;
